export default __webpack_public_path__ + "static/media/liveness-icon.3c410b27.svg";